module.exports = __webpack_public_path__ + "static/media/logo.462560fc.png";